<template>
    <div class="question mb-4">
        <div class="mb-3">
            <div class="question__title"> Какие документы об образовании обучении, из перечисленных ниже, Вы считаете наиболее значимыми в Вашей организации при принятии решения о трудоустройстве или дальнейшем карьерном росте работников?
            </div>
            <div class="question__desc caption">Выделите в соответствующих колонках справа.</div>
        </div>

        <table class="table-skills">
            <thead class="table-skills__header">
                <tr>
                    <td rowspan="2">Документы об обучении</td>
                    <td colspan="3">Категория персонала</td>
                </tr>
                <tr>
                    <td>Рабочий персонал</td>
                    <td>Специалисты</td>
                    <td>Руково-дители</td>
                </tr>
            </thead>
            <tbody>
                <tr v-for="(id, index) in ids" v-if="index%3 === 0" :key="id">
                    <td class="table-skills__text" v-if="list[id].text">{{ list[id].text }}</td>
                    <td class="table-skills__answer">
                        <question-checkbox
                                has-index
                                :index-offset="0"
                                v-if="list[ids[index]].type === 'checkbox' && list[ids[index]].answers.length"
                                :items="list[ids[index]].answers"
                                @input="$emit('sendAnswer', $event, ids[index])"
                        />
                        <question-input
                                v-else-if="list[ids[index]].type === 'input'"
                                @input="$emit('sendAnswer', $event, ids[index])"
                        />
                    </td>
                    <td class="table-skills__answer">
                        <question-checkbox
                                has-index
                                :index-offset="0"
                                v-if="list[ids[index]+1].type === 'checkbox' && list[ids[index]+1].answers.length"
                                :items="list[ids[index]+1].answers"
                                @input="$emit('sendAnswer', $event, ids[index] + 1)"
                        />
                        <question-input
                                v-else-if="list[ids[index]+1].type === 'input'"
                                @input="$emit('sendAnswer', $event, ids[index] + 1)"
                        />
                    </td>
                    <td class="table-skills__answer">
                        <question-checkbox
                                has-index
                                :index-offset="0"
                                v-if="list[ids[index]+2].type === 'checkbox' && list[ids[index]+2].answers.length"
                                :items="list[ids[index]+2].answers"
                                @input="$emit('sendAnswer', $event, ids[index] + 2)"
                        />
                        <question-input
                                v-else-if="list[ids[index]+2].type === 'input'"
                                @input="$emit('sendAnswer', $event, ids[index] + 2)"
                        />
                    </td>
                </tr>
            </tbody>
        </table>
    </div>
</template>

<script>
    import {mapGetters} from 'vuex'
    import QuestionInput from '@/components/question/input'
    import QuestionCheckbox from '@/components/question/checkbox'

    export default {
        components: {
            QuestionInput,
            QuestionCheckbox
        },
        props: {
            ids: Array
        },
        data () {
            return {
                items: [],
                value: ''
            }
        },
        computed: {
            ...mapGetters('questions', ['questions']),
            list () {
                let out = {}

                this.questions.forEach(item => {
                    out[item.id] = item
                })

                return out
            }
        }
    }
</script>

<style lang="stylus" scoped>
    .question {
        &__title {}
        &__desc {
            color #777777
        }
    }

    .table-skills {
        width 100%
        border-collapse collapse

        &__header {
            text-align center
        }

        &__text {
            width 50%
        }

        &__answer {
            text-align center

            & > div {
                display inline-block
            }

            /deep/ .checkbox {
                margin-bottom 0

                .input-group__input {
                    transform translateY(-50%)
                }
            }
        }

        td {
            padding .5rem 1rem
            border 1px solid rgba(0,0,0,0.42)
        }
    }
</style>